import React from 'react';
import styled from 'styled-components';
import {
  Drawer as AntDrawer,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { ShareCloseFilled, CopyLinkFilled } from '@assets';
import {
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  ViberIcon,
  ViberShareButton,
} from "react-share";

const Container = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100vh;
    max-width: 480px;
    z-index: ${props => props.open === 'true' ? 20 : -1};
`;

const Drawer = styled(AntDrawer)`
border-top-left-radius: 16px;
border-top-right-radius: 16px;
position: relative;

.ant-drawer-body {
    padding: 30px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 30px;
    background-color: #fff;
}
`;

const TitleWrapper = styled.div`
display: flex;
align-items: center;

svg {
    cursor: pointer;
}
`;

const Title = styled.div`
    flex: 1;
    color: #1E1E1E;
    text-align: left;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 34px; /* 141.667% */
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

@media screen and (max-width: 375px) {
    padding: 24px 16px;
}
`;

const BottomWrapper = styled.div`
`;

const Box = styled.div`
  padding: 9px 16px;
  display: flex;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #CCC;
  background: #FFF;

  svg {
      cursor: pointer;
  }
`;

const Text = styled.div`
  flex: 1;
  overflow: hidden;
  color: #1E1E1E;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */;
`;

const IconWrapper = styled.div`
display: flex;
padding: 10px;
border-radius: 10px;
background-color: #F5F5F5;

@media screen and (max-width: 380px) {
    svg {
        width: 30px;
        height: 30px;
    }
}
`;

const ShareModal = ({
  link,
  open,
  handleClose,
  copy,
}) => {
  const { t } = useTranslation();

  return (
    <Container open={open ? 'true' : 'false'}>
      <Drawer
        destroyOnClose
        autoFocus={false}
        closable={false}
        getContainer={false}
        placement='bottom'
        open={open}
        onClose={handleClose}
      >
        <TitleWrapper>
          <Title>{t("share.shareModalTitle")}</Title>
          <ShareCloseFilled onClick={handleClose} />
        </TitleWrapper>

        <BottomWrapper>
          <Box>
            <Text>{t("share.copyLink")}</Text>
            <CopyLinkFilled onClick={() => copy(link)} />
          </Box>
        </BottomWrapper>

        <ContentWrapper>

          <FacebookMessengerShareButton
            url={link}
            appId={process.env.REACT_APP_FB_APP_ID}
          >
            <IconWrapper>
              <FacebookMessengerIcon size={40} round={true} />
            </IconWrapper>
          </FacebookMessengerShareButton>

          <FacebookShareButton url={link}>
            <IconWrapper>
              <FacebookIcon size={40} round={true} />
            </IconWrapper>
          </FacebookShareButton>

          <TelegramShareButton url={link}>
            <IconWrapper>
              <TelegramIcon size={40} round={true} />
            </IconWrapper>
          </TelegramShareButton>

          <ViberShareButton url={link}>
            <IconWrapper>
              <ViberIcon size={40} round={true} />
            </IconWrapper>
          </ViberShareButton>

        </ContentWrapper>
      </Drawer>
    </Container>
  )
}

export default ShareModal